import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { planReleasesEntryPoint } from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-releases/entrypoint.tsx';
import { plansHorizontalNavigationEntryPoint } from '@atlassian/jira-horizontal-nav-plans/entrypoint.tsx';

export const planReleasesPageEntryPoint = createPageEntryPoint({
	main: planReleasesEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
	horizontalNavigation: plansHorizontalNavigationEntryPoint,
});

export const planReleasesPageEntryPointWithoutHorizontalNavigation = createPageEntryPoint({
	main: planReleasesEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
});
